import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context';

export const PublicOnlyRoute = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    const from = (location.state as { from?: string } | undefined)?.from;
    return <Navigate to={from ?? '/dashboard'} replace />;
  }

  return <Outlet />;
};

export default PublicOnlyRoute;

